import React from "react";
import { AccountingAccount } from "../services/accounting-account-service";

interface Props {
  open: boolean;
  onClose: () => void;
  data?: AccountingAccount | null;
}

export const AccountingAccountDetail: React.FC<Props> = ({ open, onClose, data }) => {
  if (!open || !data) return null;

  const typeText = (t?: number) => {
    switch (t) {
      case 1:
        return "Tài khoản Tổng hợp";
      case 2:
        return "Tài khoản Chi tiết";
      default:
        return "—";
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 animate-fadeIn">
      <div className="bg-white rounded-2xl w-[540px] shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 to-green-500 text-white px-6 py-3 flex justify-between items-center">
          <h3 className="text-lg font-semibold">Chi tiết tài khoản kế toán</h3>
          <button
            onClick={onClose}
            className="text-white text-2xl leading-none hover:opacity-80"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4 text-gray-800">
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Mã tài khoản</p>
            <p className="text-base text-black">{data.code || "—"}</p>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Tên tài khoản</p>
            <p className="text-base text-black">{data.name || "—"}</p>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Tên tiếng Anh</p>
            <p className="text-base text-black">{data.english_name || "—"}</p>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Loại tài khoản</p>
            <p className="text-base text-black">{typeText(data.type)}</p>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Mô tả</p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-base text-gray-800 min-h-[60px] whitespace-pre-line">
              {data.description || "Không có mô tả"}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-semibold text-gray-600 mb-1">Dư Có</p>
              <p className="text-base text-black">
                {Number(data.credit ?? 0).toLocaleString()}
              </p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-600 mb-1">Dư Nợ</p>
              <p className="text-base text-black">
                {Number(data.debit ?? 0).toLocaleString()}
              </p>
            </div>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Trạng thái</p>
            <p
              className={`text-base ${
                data.status === 1 ? "text-green-700" : "text-gray-700"
              }`}
            >
              {data.status === 1 ? "Hoạt động" : "Tạm ngưng"}
            </p>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Ngày tạo</p>
            <p className="text-base text-black">{data.created_at || "—"}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition font-medium"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};
